/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Models_MidInputs */

const en_mk_mx_models_mid = /** @type {(inputs: Mk_Mx_Models_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid-tier models for longer work`)
};

const id_mk_mx_models_mid = /** @type {(inputs: Mk_Mx_Models_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model menengah untuk tugas panjang`)
};

/**
* | output |
* | --- |
* | "Mid-tier models for longer work" |
*
* @param {Mk_Mx_Models_MidInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_models_mid = /** @type {((inputs?: Mk_Mx_Models_MidInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Models_MidInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_models_mid(inputs)
	return en_mk_mx_models_mid(inputs)
});